
<footer class="footer p-1">
  <div fxLayout="row wrap" fxLayoutAlign="space-between center">
    <img class="brand-footer" src="./../../../../assets/img/logos-footer.png" width="250" alt="">
    <app-social-networks></app-social-networks>
  </div>
</footer>
